import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import Cookies from "universal-cookie";
import { Button, Input } from "../../components/ui";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import RoundedContainer from "../../components/containers/RoundedContainer";
import InlineLoader from "../../components/loader/InlineLoader";
import { ROLE } from "../../config";
import { usePettyCashSettings } from "../../hooks/petty_cash/usePettyCashSettings";

const cookies = new Cookies();

function PettyCashSettings() {
  const role = cookies.get(ROLE);
  const isAdmin = role === "COMPANY_ADMIN";

  const { settingsData, saveSettings, isSaving } = usePettyCashSettings();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      prior_no_days: "",
    },
  });

  const currentSettings = settingsData.data?.data;

  useEffect(() => {
    if (currentSettings) {
      if (Array.isArray(currentSettings)) {
        reset({ prior_no_days: "" });
      } else {
        reset({ prior_no_days: currentSettings.prior_no_days || "" });
      }
    }
  }, [currentSettings, reset]);

  const onSubmit = (data) => {
    saveSettings({
      prior_no_days: data.prior_no_days,
    });
  };

  return (
    <div className="py-6 px-4 md:px-8 bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto space-y-6">
        <BreadCrumbs
          crumbs={[
            { label: "Dashboard", link: "/" },
            { label: "Petty Cash Settings", link: "" },
          ]}
        />
        <div>
          <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">Prior Date Settings</h1>
          <p className="text-gray-500 mt-1">
            {isAdmin
              ? "Configure the maximum number of prior days allowed for transaction dates."
              : "View the current prior date settings."}
          </p>
        </div>

        {settingsData.isLoading ? (
          <div className="flex items-center justify-center py-12 w-full">
            <InlineLoader className="w-8 h-8 text-primary" />
          </div>
        ) : (
          <RoundedContainer className="p-6 shadow-sm border border-gray-150">
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              <div className="max-w-md">
                <Input
                  control={control}
                  label="Prior Number of Days"
                  name="prior_no_days"
                  type="number"
                  isInteger={true}
                  isPositiveNumber={true}
                  placeholder="Enter number of days"
                  disabled={!isAdmin}
                  rules={{
                    required: "Prior number of days is required",
                    min: { value: 0, message: "Value must be 0 or greater" },
                  }}
                />
                <p className="text-xs text-gray-400 mt-1">
                  Maximum number of prior days allowed for expense date entries.
                </p>
              </div>

              {isAdmin && (
                <div className="flex items-center justify-end pt-4 border-t border-gray-100">
                  <Button type="submit" disabled={isSaving}>
                    {isSaving ? (
                      <>
                        <span>Saving...</span>
                        <InlineLoader className="ml-2" />
                      </>
                    ) : (
                      "Save Settings"
                    )}
                  </Button>
                </div>
              )}
            </form>
          </RoundedContainer>
        )}
      </div>
    </div>
  );
}

export default PettyCashSettings;
